import React, { PureComponent } from 'react';
import { FlexCol, FlexContainer, FlexRow } from 'sarsaparilla';
import { Link } from 'react-router-dom';

import styles from './Footer.scss';

const ContactUsUrl = `${process.env.SITE_ROOT}/contact-us`;
const year = new Date().getFullYear();

export class Footer extends PureComponent {
  render() {
    return (
      <footer role="contentinfo" className={styles.footer}>
        <FlexContainer>
          <FlexRow>
            <FlexCol sm="variable">
              <span>
                © {year} Recreation.gov. All Rights Reserved
              </span>
            </FlexCol>
            <FlexCol>
              <a className="contact-us" href={ContactUsUrl}>
                Contact Us
              </a>
              &nbsp; &nbsp;
              <Link to="/changelog">Changelog</Link>
            </FlexCol>
          </FlexRow>
        </FlexContainer>
      </footer>
    );
  }
}

export default Footer;
